import React from 'react';

interface PlusPrimaryIconProps {
  width?: number;
  height?: number;
  style?: React.CSSProperties;
}

export const PlusPrimaryIcon: React.FC<PlusPrimaryIconProps> = ({ width = 16, height = 16, style }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
      <path
        d="M11.9997 8.6653H8.66634V11.9986C8.66634 12.1754 8.5961 12.345 8.47108 12.47C8.34605 12.5951 8.17649 12.6653 7.99967 12.6653C7.82286 12.6653 7.65329 12.5951 7.52827 12.47C7.40325 12.345 7.33301 12.1754 7.33301 11.9986V8.6653H3.99967C3.82286 8.6653 3.65329 8.59507 3.52827 8.47004C3.40325 8.34502 3.33301 8.17545 3.33301 7.99864C3.33301 7.82183 3.40325 7.65226 3.52827 7.52723C3.65329 7.40221 3.82286 7.33197 3.99967 7.33197H7.33301V3.99864C7.33301 3.82183 7.40325 3.65226 7.52827 3.52723C7.65329 3.40221 7.82286 3.33197 7.99967 3.33197C8.17649 3.33197 8.34605 3.40221 8.47108 3.52723C8.5961 3.65226 8.66634 3.82183 8.66634 3.99864V7.33197H11.9997C12.1765 7.33197 12.3461 7.40221 12.4711 7.52723C12.5961 7.65226 12.6663 7.82183 12.6663 7.99864C12.6663 8.17545 12.5961 8.34502 12.4711 8.47004C12.3461 8.59507 12.1765 8.6653 11.9997 8.6653Z"
        fill="#774EFF"
      />
    </svg>
  );
};
